import { Heading } from "@medoma/components/Heading/Heading";
import { Loading } from "@medoma/components/Loading/Loading";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import * as Sentry from "@sentry/react";
import styles from "./guide.module.scss";
import { GoBackLink } from "@/routes/profile/goBackLink";
import { usePatient } from "@/api/patient";
import { getInformationText } from "./informationText";
import { Trans, useLingui } from "@lingui/react/macro";
import { getPatientGivenName } from "@medoma/models/patients";

export const Guide = () => {
  const { t } = useLingui();
  const { data: patient, isPending, isError, error } = usePatient();

  if (isPending) {
    return <Loading message={t`Hämtar informationstext`} />;
  }

  if (isError) {
    Sentry.captureException(error);
    return <ErrorMessage message={t`Kunde inte hämta informationstexten`} />;
  }

  const patientFirstName = getPatientGivenName(patient.name);
  const informationText = getInformationText(patient.site.id);

  return (
    <>
      <GoBackLink />
      <img
        src={informationText.imagePath[480]}
        srcSet={`${informationText.imagePath[480]} 480w, ${informationText.imagePath[768]} 768w, ${informationText.imagePath[1366]} 1366w`}
        sizes="(max-width: 480px) 480px, (max-width: 768px) 768px, (max-width: 1366px) 1366px"
        width="480px"
        height="270px"
        alt={t`Så vårdas du`}
        className={styles.image}
      />
      <div className={styles.container}>
        <Heading level="h1" margin="bottom">
          <Trans>Så vårdas du</Trans>
        </Heading>
        <Heading level="h2" margin="bottom">
          <Trans>Hej {patientFirstName}!</Trans>
        </Heading>
        {informationText.jsxText}
      </div>
    </>
  );
};
